"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castWithOptions = exports.cast = exports.CastError = void 0;
const lambda_1 = require("@webnuts/lambda");
// @ts-ignore
const caster_1 = require("./caster");
class CastError extends Error {
    constructor(declaration, candidate) {
        const type = declaration.type === 'Union' ? declaration.declarations.map((d) => d.type).join(' | ') : declaration.type;
        const candidateTypeString = lambda_1.toTypeString(candidate);
        const message = `Unable to cast "${candidateTypeString}" to type "${type}"`;
        super(message);
    }
}
exports.CastError = CastError;
function cast(declaration, candidate) {
    if (arguments.length === 0) {
        return cast;
    }
    else if (arguments.length === 1) {
        return (c) => cast(declaration, c);
    }
    return castWithOptions(declaration, {}, candidate);
}
exports.cast = cast;
function castWithOptions(declaration, options, candidate) {
    if (arguments.length === 0) {
        return castWithOptions;
    }
    else if (arguments.length === 1) {
        return (o) => (c) => castWithOptions(declaration, o, c);
    }
    const caster = caster_1.createCaster(declaration, options);
    const { candidate: castedCandidate, ...validation } = caster(candidate);
    if (validation.isValid) {
        return castedCandidate;
    }
    throw new CastError(declaration, candidate);
}
exports.castWithOptions = castWithOptions;
